import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FeatureFlags, FeatureFlagVariants } from '@app/core/feature-flags/feature-flags';
import { LaunchDarklyService } from '@app/core/feature-flags/launchdarkly.service';
import { StateService } from '@app/shared/state.service';

@Component({
  selector: 'om-address-basic-input',
  templateUrl: './address-basic-input.component.html',
  styleUrls: ['../../form-input.scss'],
})
export class AddressBasicInputComponent implements OnInit {
  @Input() address: UntypedFormGroup;
  @Input() isRpcEligible = false;

  constructor(private launchDarklyService: LaunchDarklyService, public stateService: StateService) {}

  ngOnInit() {
    this.launchDarklyService
      .featureFlag$(FeatureFlags.REMOTE_PRIMARY_CARE_ENABLED, FeatureFlagVariants.OFF)
      .subscribe(flag => {
        const isEnabled = flag !== FeatureFlagVariants.OFF;
        if (isEnabled) {
          if (this.isRpcEligible) {
            this.updateFieldsDisabledState();
          }
        }
      });
  }

  private updateFieldsDisabledState() {
    if (!this.address) {
      return;
    }
    const fieldNames = ['state', 'zip'];
    fieldNames.forEach(fieldName => {
      const control = this.address.get(fieldName);
      if (control) {
        control.disable();
      }
    });
  }
}
